import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Resource } from '@klickdata/core/resource';
import { AuthService } from '@klickdata/core/auth';
import { User } from '@klickdata/core/user';
import { Observable } from 'rxjs';
import { first, tap } from 'rxjs/operators';
import { Filter } from '@klickdata/core/table';

@Component({
    selector: 'app-scorm-manager-files',
    templateUrl: './scorm-manager-files.component.html',
    styleUrls: ['./scorm-manager-files.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScormManagerFilesComponent implements OnInit {
    @Input() resource: Resource;
    public authUser: Observable<User>;
    public tableFilterItems: Filter<string | number>[];
    constructor(protected auth: AuthService) {}

    ngOnInit(): void {
        this.authUser = this.auth.getUser().pipe(
            first(),
            tap((user) => {
                this.tableFilterItems = [
                    { property: 'customer', items: [user.customer_id] },
                    { property: 'limit', items: [10] },
                ];
            })
        );
    }
}
